import { colorTint, statusColor } from '@utils/index';

/**
 * Status pill (desktop cells at 16px, mobile cards at 14px): text in the
 * status color on a light (10%) tint of the same color.
 */
const StatusPill = ({
  status,
  fontSize = 14,
  color,
}: {
  status?: string | null;
  fontSize?: number;
  /** Override the color map (e.g. a computed overdue state). */
  color?: string;
}) => {
  if (!status) return null;
  const resolved = color || statusColor(status);
  return (
    <span
      style={{
        fontSize,
        fontWeight: 400,
        padding: '4px 8px',
        borderRadius: 4,
        color: resolved,
        background: colorTint(resolved),
        whiteSpace: 'nowrap',
        lineHeight: 1.25,
      }}>
      {status}
    </span>
  );
};

export default StatusPill;
